import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const BookingObjectServiceConfig = {
  name: "BookingObject",
  annotations: []
} as ServiceConfig;